module.exports = __webpack_public_path__ + "img/广告-5 - 杜康解忧.efa323c6.jpg";